import { action } from 'satcheljs';

/**
 * Action to set the store, whether it is search mode or not.
 */
export let setSearchState = action('setSearchState', (isInSearchMode: boolean) => ({
    isInSearchMode,
}));
